import React from "react";
import { useParams } from "react-router-dom";
import PaymentErrorWrapperArea from "./PaymentErrorWrapperArea";

function PaymentError() {

  const { ctype } = useParams(); // mode will be "online" or "onsite"
  const { hash } = useParams(); // hash is the unique booking hash

  return (
    <>
      <PaymentErrorWrapperArea ctype={ctype} hash={hash} />
    </>
  );
}

export default PaymentError;
